export const EMOJI_LABEL_SYMBOLS = [
  'Bullseye',
  'Fire',
  'Confetti Ball',
  'Party Popper',
  'Sparkle',
  'Fireworks',
  'Sparkler',
  'Sparkles',
  'Pinata',
  'Money with Wings',
  'Money Bag',
  'Cocktail Glass',
  'Clinking Beer Mugs',
  'Bottle with Popping Cork',
  'Hundred Points',
  'Red Exclamation Mark',
  'Triangular Flag',
  'Balloon',
  'Wrapped Gift',
  'Airplane',
  'Rocket',
  'Four Leaf Clover',
  'Blue Heart',
  'Beating Heart',
  'Books',
  'Trophy',
  'Medal',
  'Sun with Face'
];

export const EMOJI_LABEL_HAND = [
  'Waving Hand',
  'Crossed Fingers',
  'Raised Hand',
  'Sign of the horns',
  'Vulcan Salute',
  'Folded Hands',
  'Raising Hands',
  'Writing Hand',
  'Victory Hand',
  'Index Pointing Up',
  'Backhand Index Pointing Down',
  'Backhand Index Pointing Right',
  'Backhand Index Pointing Left',
  'Backhand Index Pointing Up',
  'Clapping Hands',
  'Oncoming Fist',
  'OK Hand',
  'Flexed Biceps',
  'Raised Back of Hand',
  'Thumbs Down',
  'Thumbs Up'
];

export const EMOJI_LABEL_PPL = [
  'Slightly Smiling Face',
  'Upside-Down Face',
  'Grinning Squinting Face',
  'Grinning Face with Sweat',
  'Face with Tears of Joy',
  'Winking Face with Tongue',
  'Squinting Face with Tongue',
  'Smiling Face with Sunglasses',
  'Smiling Face with Smiling Eyes',
  'Smiling Face with Halo',
  'Relieved Face',
  'Smiling Face with Heart-Eyes',
  'Face Blowing a Kiss',
  'Smiling Face with Horns',
  'Face with Tongue',
  'Face Savoring Food',
  'Rolling on the Floor Laughing',
  'Grinning Face with Smiling Eyes',
  'Money-Mouth Face',
  'Smiling Face with Open Hands',
  'Grinning Face',
  'Slightly Frowning Face',
  'Weary Face',
  'Face with Crossed-Out Eyes',
  'Thinking Face',
  'Winking Face',
  'Smirking Face',
  'Anguished Face',
  'Nerd Face',
  'Face with Open Mouth',
  'Enraged Face',
  'Downcast Face with Sweat',
  'Unamused Face',
  'Pensive Face',
  'Confounded Face',
  'Confused Face',
  'Face Without Mouth',
  'Disappointed Face',
  'Hushed Face',
  'Astonished Face',
  'Loudly Crying Face',
  'Tired Face',
  'Sad but Relieved Face',
  'Flushed Face',
  'Fearful Face',
  'Anxious Face with Sweat',
  'Crying Face',
  'Zipper-Mouth Face',
  'Face Screaming in Fear',
  'Woman Dancing',
  'Person Bowing',
  'Clown Face',
  'See-No-Evil Monkey',
  'Hear-No-Evil Monkey',
  'Speak-No-Evil Monkey',
  'Pile of Poo'
];
